import React, { useEffect } from 'react'
import { ALERT } from '../../components/CustomAlert'
import { EncryptedText } from '../../utils/Encryption';

function Test() {
    useEffect(() => {
        // ALERT.customAlert('แจ้งเตือน', 'กล้องของท่านไม่สามารถใช้งานกล้องได้ (Camera is not support this device)', 'ข้ามขั้นตอนนี้', () => console.log('direction!'))
        console.log('Enc: member_lab_data: ', EncryptedText('member_lab_data'));
    }, [])
  return (
    <div>Test</div>
  )
}

export default Test